<div class="modal">
  <div class="card card--md">
    <div class="card-header">
      <h3 class="card-title">Dodatne informacije o dokumentu</h3>
    </div>
    <div class="card-body">
      <!--Info for the last log-->
      <div *ngIf="document.logs && document.logs.length > 0" class="col-12">
        <div class="row">
          <span class="mb-15">
            <span class="font-weight-bold">Komentar: </span>
            <span>{{ document.logs[0].comment.split('\n').join('. ') }}.</span>
          </span>
        </div>
        <div *ngIf="document.logs[0].editedBy" class="row">
          <p><span class="font-weight-bold">Kreirao:</span> {{ document.logs[0].editedBy }}</p>
        </div>
        <div class="row">
          <p><span class="font-weight-bold">Datum:</span> {{ document.logs[0].date | date : 'dd/MM/yyyy' }}</p>
        </div>
        <div class="row">
          <p><span class="font-weight-bold">Vreme:</span> {{ customFunctions.getTime(document.logs[0].date) }}</p>
        </div>
      </div>

      <hr *ngIf="document.logs && document.logs.length > 1" class="mt-5 mb-10" />

      <div *ngIf="document.logs && document.logs.length > 1" class="row pointer" (click)="toggleHistoryLog()">
        <div class="col-12">
          <div class="d-flex justify-content-between">
            <div>
              <i class="fa fa-history"></i>
              <span class="ml-10 mr-10">Istorija aktivnosti</span>
            </div>
            <i class="fa fa-chevron-{{ isHistoryLogOpen ? 'up' : 'down' }}"></i>
          </div>
        </div>
      </div>
      <div class="d-none mt-20" [class.d-flex]="isHistoryLogOpen">
        <div class="col-12 scrollable p-0">
          <div
            class="d-flex justify-content-between align-content-center border border-radius-2 mt-10 p-5"
            *ngFor="let log of document.logs.slice(1)">
            <div class="col-3">{{ log.editedBy }}</div>
            <div class="col-6">{{ log.comment }}</div>
            <div class="col-3">{{ log.date | date : 'dd/MM/yyyy' }} {{ customFunctions.getTime(log.date) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question" (click)="emitFalse()">Nazad</button>
    </div>
  </div>
</div>
